import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { LOCAL_STORAGE, SESSION_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import "rxjs/add/operator/timeoutWith";
import "rxjs/add/observable/defer"
import "rxjs/add/observable/throw"


import { DataViewModel } from '../../models/DataViewModel';
import { Culture } from '../../models/common/culture';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';

@Injectable()
export class TranslationService {
    baseUrl: string;
    static currentCulture: Culture = {
        code: 'none',
        title: ''
    };
    static explicitCulture: Culture;

    static queue: Array<() => void> = new Array<() => void>();

    constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string, @Inject(SESSION_STORAGE) private storage: WebStorageService) {
        this.baseUrl = baseUrl;
    }

    public getTranslation(culture: string, code: string): Observable<DataViewModel<string>> {
        return this.http.get(this.baseUrl + 'api/Translation/GetTranslation?culture=' + culture + '&code=' + code)
            .map(response => <DataViewModel<string>>response)
            .timeoutWith(60000, Observable.defer(() => Observable.throw(Observable.throw('Translation process timed out'))))
            .catch(this.handleError);
    }

    public translate(code: string, defaultText: string, func: (a: string) => void) {
        if (TranslationService.isDefaultCultureEmpty()) {

            TranslationService.queue.push(() => {
                this.translate(code, defaultText, func);
            });
        } else {
            var key = TranslationService.currentCulture.code + '.' + code;
            var translation = this.storage.get(key);
            if (translation != null) {
                func(translation);
            } else {
                var response = this.getTranslation(TranslationService.currentCulture.code, code);
                response.subscribe(translated => {
                    if (translated.success && translated.data != null) {
                        func(translated.data);
                        this.storage.set(key, translated.data);
                    } else {
                        func(defaultText);
                    }
                });
            }
        }
    }
    
    private handleError(response: ErrorObservable ) {
        console.error(response);
        return Observable.throw(response.error || 'Server error');
    }

    public getSupportedCultures(func: (cultures: Culture[]) => void): void {
        this.http.get(this.baseUrl + 'api/Translation/GetSupportedCultures')
            .map(response => <DataViewModel<Culture[]>>response)
            .timeoutWith(60000, Observable.defer(() => Observable.throw(Observable.throw('Translation process timed out'))))
            .catch(this.handleError)
            .subscribe(response => {
                if (response.success && response.data != null) {
                    func(response.data);
                }
            });
    }

    public setDefaultCulture(func: (culture: Culture) => void): void {
        this.http.get(this.baseUrl + 'api/Translation/GetDefaultCulture')
            .map(response => <DataViewModel<Culture>>response)
            .timeoutWith(60000,
                Observable.defer(() => Observable.throw(Observable.throw('Translation process timed out'))))
            .catch(this.handleError)
            .subscribe(response => {
                    if (response.success && response.data != null) {
                        TranslationService.currentCulture = response.data;
                    }
                },
                this.handleError,
                () => {
                    func(TranslationService.currentCulture);
                    TranslationService.queue.forEach(q => q());
                });
    }

    public static isDefaultCultureEmpty(): boolean {
        return TranslationService.currentCulture.code === 'none';
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/services/common/translation.service.ts